export default __webpack_public_path__ + "static/media/oven.5e94ad1f.svg";